module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    class: ['close-trip-summary' + (_vm.showTripDetails ? ' show' : '')],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toggleTripDetails
    }
  }, [_c('icon', {
    attrs: {
      "name": "remove"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "trip-details-header",
    on: {
      "click": _vm.toggleTripDetails
    }
  }, [(_vm.showTripDetails) ? _c('span', {
    staticClass: "trip-details-header-text"
  }, [_vm._v(_vm._s(_vm.$t('rsvpDetails.hideTrip')))]) : _c('span', {
    staticClass: "trip-details-header-text"
  }, [_vm._v(_vm._s(_vm.$t('rsvpDetails.showTrip')))]), _vm._v(" "), (_vm.showTripDetails) ? _c('span', {
    staticClass: "trip-details-header-icon"
  }, [_c('icon', {
    attrs: {
      "name": "caret-down"
    }
  })], 1) : _c('span', {
    staticClass: "trip-details-header-icon"
  }, [_c('icon', {
    attrs: {
      "name": "caret-up"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: ['trip-details card padding-a-z margin-b-l' + (_vm.showTripDetails ? ' show' : '')]
  }, [_c('h2', {
    staticClass: "margin-a-z padding-t-m padding-l-m"
  }, [_vm._v(_vm._s(_vm.$t('rsvpDetails.tripSummary')))]), _vm._v(" "), (_vm.showRoundTripTab) ? _c('div', [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    class: [(_vm.leg1Tab ? 'active' : '')],
    on: {
      "click": _vm.switchLegTabs
    }
  }, [_vm._v(_vm._s(_vm.$t('common.leg')) + " 1")]), _vm._v(" "), _c('li', {
    class: [(_vm.leg2Tab ? 'active' : '')],
    on: {
      "click": _vm.switchLegTabs
    }
  }, [_vm._v(_vm._s(_vm.$t('common.leg')) + " 2")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-border"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-contents"
  }, [_c('div', {
    class: ['tab-content' + (_vm.leg1Tab ? ' active' : '')]
  }, [(_vm.rerender) ? _c('reservation-details-header', {
    key: _vm.rsvpDetailsHeaderKey,
    attrs: {
      "leg": _vm.leg1,
      "currentLeg": "leg1",
      "user": _vm.user,
      "brand": _vm.brand,
      "flash": _vm.flash,
      "otherLeg": _vm.leg2
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: ['tab-content' + (_vm.leg2Tab ? ' active' : '')]
  }, [(_vm.rerender) ? _c('reservation-details-header', {
    attrs: {
      "leg": _vm.leg2,
      "currentLeg": "leg2",
      "user": _vm.user,
      "brand": _vm.brand,
      "flash": _vm.flash,
      "otherLeg": _vm.leg1
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-026ea42c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026ea42c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservation/ReservationDetails.vue
// module id = 2025
// module chunks = 0